import { createSingleEntityStore } from '@recruitee/ngrx';
import type { StatsSidebar } from '@recruitee/stats-types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<StatsSidebar>()('DashboardStatsSidebar');

export {
  actions as DashboardStatsSidebarActions,
  selectors as DashboardStatsSidebarSelectors,
  reducer as DashboardStatsSidebarReducer,
  namespace as DashboardStatsSidebarNamespace,
};
